import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { authRoutes, publicRoutes, adminRoutes } from './routes';
import { LOGIN_ROUTE } from './utils/consts';

const AppRouter = () => {
	const is_logged_in = true;
	const is_admin = true;

	return (
		<Routes>
			{publicRoutes.map(({ path, Component }) => (
				<Route key={path} path={path} element={<Component />} exact />
			))}
			{is_logged_in &&
				authRoutes.map(({ path, Component }) => (
					<Route key={path} path={path} element={<Component />} exact />
				))}
			{is_admin &&
				adminRoutes.map(({ path, Component }) => (
					<Route key={path} path={path} element={<Component />} exact />
				))}
			<Route path='*' element={<Navigate to={LOGIN_ROUTE} />} />
		</Routes>
	);
};

export default AppRouter;
